module.exports = __webpack_public_path__ + "img/applet.a6212690.png";